/* =========================================================
   CortTech London — Custom Global Scripts
   Extraído do protótipo HTML original.
   Colocar este ficheiro em: assets/custom-global.js
   Carregar no theme.liquid, antes do </body>, com defer:
   <script src="{{ 'custom-global.js' | asset_url }}" defer></script>

   NOTA: este ficheiro assume os IDs do header custom
   (navtoggle / navlinks) e, se existirem nas páginas,
   os IDs dos carrosséis, tabela de comparação e formulário
   do protótipo original. Se não usares essas secções no
   Shopify, podes remover os blocos correspondentes abaixo
   sem problema — cada bloco está isolado e verifica se o
   elemento existe antes de correr.
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

    /* ---- Menu mobile (usado pelo header custom) ---- */
  const navtoggle = document.getElementById('navtoggle');
  const navlinks = document.getElementById('navlinks');
  if (navtoggle && navlinks) {
    navtoggle.addEventListener('click', (e) => {
      e.stopPropagation();
      navlinks.classList.toggle('open');
    });
    navlinks.querySelectorAll('a').forEach(a =>
      a.addEventListener('click', () => navlinks.classList.remove('open'))
    );

    // Fechar ao clicar/tocar fora do menu
    function closeIfOutside(e) {
      const clickedInsideMenu = navlinks.contains(e.target);
      const clickedToggle = navtoggle.contains(e.target);
      if (!clickedInsideMenu && !clickedToggle && navlinks.classList.contains('open')) {
        navlinks.classList.remove('open');
      }
    }
    document.addEventListener('click', closeIfOutside, true);
    document.addEventListener('touchstart', closeIfOutside, true);

    // Fechar ao fazer scroll
    window.addEventListener('scroll', () => {
      if (navlinks.classList.contains('open')) {
        navlinks.classList.remove('open');
      }
    }, { passive: true });
  }

  /* ---- Verificar disponibilidade de domínio (secção "Start a project") ---- */
  const checkDomainBtn = document.getElementById('checkDomain');
  if (checkDomainBtn) {
    checkDomainBtn.addEventListener('click', () => {
      const domainInput = document.getElementById('domain');
      const domain = domainInput ? domainInput.value.trim() : '';
      if (!domain) {
        alert('Please type a domain name first, for example: almabakery.com');
        return;
      }
      const url = 'https://www.godaddy.com/domainsearch/find?domainToCheck=' + encodeURIComponent(domain);
      window.open(url, '_blank', 'noopener');
    });
  }

  /* ---- Pré-visualização de upload de imagens (logo / galeria) ---- */
  function wireUpload(inputId, previewId) {
    const input = document.getElementById(inputId);
    const preview = document.getElementById(previewId);
    if (!input || !preview) return;
    input.addEventListener('change', () => {
      preview.innerHTML = '';
      Array.from(input.files).forEach(file => {
        const reader = new FileReader();
        reader.onload = e => {
          const img = document.createElement('img');
          img.src = e.target.result;
          preview.appendChild(img);
        };
        reader.readAsDataURL(file);
      });
    });
  }
  wireUpload('logo', 'logoPreview');
  wireUpload('gallery', 'galleryPreview');

  /* ---- Pré-selecionar pacote via parâmetro ?package=slug na URL ---- */
  (function preselectPackage() {
    const select = document.getElementById('pkg');
    if (!select) return;
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('package');
    if (!slug) return;
    const match = Array.from(select.options).find(o => o.dataset.slug === slug);
    if (match) select.value = match.value;
  })();

  /* ---- Carrosséis (exemplos de sites / testemunhos) ---- */
  function initCarousel(trackId, dotsId, prevId, nextId) {
    const track = document.getElementById(trackId);
    const dotsWrap = document.getElementById(dotsId);
    const prevBtn = document.getElementById(prevId);
    const nextBtn = document.getElementById(nextId);
    if (!track || !dotsWrap || !prevBtn || !nextBtn) return;

    const slides = Array.from(track.children);
    if (slides.length === 0) return;

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });
    const dots = Array.from(dotsWrap.children);

    function slideWidth() {
      const style = getComputedStyle(track);
      return slides[0].offsetWidth + parseFloat(style.columnGap || style.gap || 24);
    }

    prevBtn.addEventListener('click', () => track.scrollBy({ left: -slideWidth(), behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => track.scrollBy({ left: slideWidth(), behavior: 'smooth' }));

    function updateActiveDot() {
      const pos = track.scrollLeft;
      let closest = 0;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs((slide.offsetLeft - track.offsetLeft) - pos);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      dots.forEach((d, i) => d.classList.toggle('active', i === closest));
    }

    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 80);
    });
    updateActiveDot();
  }
  initCarousel('examplesTrack', 'examplesDots', 'examplesPrev', 'examplesNext');
  initCarousel('testiTrack', 'testiDots', 'testiPrev', 'testiNext');

  /* ---- Envio do formulário "Start a project" ---- */
  const projectForm = document.getElementById('projectForm');
  if (projectForm) {
    projectForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const status = document.getElementById('formStatus');
      if (status) {
        status.textContent = "Thank you! Your details are ready to send — connect this form to an email service to go live.";
      }
    });
  }

});